/**
 * Registry of published guide articles (Phase 1 + Phase 2).
 * Slugs are French; English equivalents are in slugEn for hreflang reference.
 */
export const GUIDE_ARTICLES = [
  {
    id: 's1',
    slug: '/guides/assistance-video-souveraine-france',
    slugEn: '/guides/sovereign-video-support-france',
    related: ['s2', 's3', 's7', 's6'],
    schemas: ['article', 'faqPage'],
    published: '2026-05-22',
  },
  {
    id: 'c1',
    slug: '/guides/assistance-video-marque-blanche',
    slugEn: '/guides/white-label-video-support',
    related: ['c2', 'c8', 'c3'],
    schemas: ['article', 'faqPage'],
    published: '2026-05-22',
  },
  {
    id: 's2',
    slug: '/guides/teams-zoom-sav-risques-dpo',
    slugEn: '/guides/teams-zoom-support-dpo-risks',
    related: ['s1', 'r5', 's4'],
    schemas: ['article', 'faqPage'],
    published: '2026-05-22',
  },
  {
    id: 's3',
    slug: '/guides/rgpd-assistance-video-clients-finaux',
    slugEn: '/guides/gdpr-video-support-end-customers',
    related: ['s1', 's4'],
    schemas: ['article', 'faqPage'],
    published: '2026-05-22',
  },
  {
    id: 'g1',
    slug: '/guides/geolocalisation-client-panne-gps-smartphone',
    slugEn: '/guides/locate-customer-breakdown-gps-smartphone',
    related: ['s4', 's1', 'q1'],
    schemas: ['article', 'faqPage', 'howTo'],
    published: '2026-05-22',
  },
  {
    id: 'c2',
    slug: '/guides/domaine-personnalise-assistance-video',
    slugEn: '/guides/custom-domain-video-support',
    related: ['c1', 'c8'],
    schemas: ['article', 'faqPage', 'howTo'],
    published: '2026-05-22',
  },
  {
    id: 's4',
    slug: '/guides/gps-client-sav-rgpd-sans-tracking',
    slugEn: '/guides/customer-gps-support-gdpr-no-tracking',
    related: ['g1', 's3', 's1'],
    schemas: ['article', 'faqPage'],
    published: '2026-05-22',
  },
  {
    id: 'q1',
    slug: '/guides/qr-code-support-technique-equipement',
    slugEn: '/guides/qr-code-technical-support-equipment',
    related: ['g1', 'c3', 'r1'],
    schemas: ['article', 'faqPage'],
    published: '2026-05-22',
  },
  {
    id: 'c3',
    slug: '/guides/qr-code-personnalise-marque-etiquettes',
    slugEn: '/guides/custom-branded-qr-code-labels',
    related: ['c1', 'q1', 'q2'],
    schemas: ['article', 'faqPage'],
    published: '2026-05-22',
  },
  {
    id: 's6',
    slug: '/guides/assistance-video-hebergement-on-premise',
    slugEn: '/guides/video-support-on-premise-hosting',
    related: ['s1', 'c7'],
    schemas: ['article', 'faqPage'],
    published: '2026-05-22',
  },
  {
    id: 'r1',
    slug: '/guides/reduire-deplacements-inutiles-sav',
    slugEn: '/guides/reduce-unnecessary-service-trips',
    related: ['g1', 's1', 'q1'],
    schemas: ['article', 'faqPage', 'howTo'],
    published: '2026-05-22',
  },
  {
    id: 's7',
    slug: '/guides/galene-moteur-video-open-source-assistance',
    slugEn: '/guides/galene-open-source-video-engine-support',
    related: ['s1', 's6'],
    schemas: ['article', 'faqPage'],
    published: '2026-05-22',
  },
  {
    id: 'c8',
    slug: '/guides/avant-apres-marque-blanche-assistance-video',
    slugEn: '/guides/before-after-white-label-video-support',
    related: ['c1', 'c2'],
    schemas: ['article', 'faqPage'],
    published: '2026-05-22',
  },
  // Phase 2
  {
    id: 'g2',
    slug: '/guides/location-velo-panne-gps-smartphone',
    slugEn: '/guides/bike-rental-breakdown-gps-smartphone',
    related: ['g1', 'm1', 'q1'],
    schemas: ['article', 'faqPage'],
    published: '2026-05-22',
  },
  {
    id: 'g3',
    slug: '/guides/carte-flotte-gps-sans-tracker',
    slugEn: '/guides/fleet-map-gps-without-tracker',
    related: ['g1', 'q2'],
    schemas: ['article', 'faqPage'],
    published: '2026-05-22',
  },
  {
    id: 'q2',
    slug: '/guides/imprimer-qr-codes-flotte-materiel',
    slugEn: '/guides/bulk-print-qr-codes-equipment-fleet',
    related: ['q1', 'c3'],
    schemas: ['article', 'faqPage'],
    published: '2026-05-22',
  },
  {
    id: 'q3',
    slug: '/guides/depannage-box-internet-domotique-distance',
    slugEn: '/guides/remote-internet-box-smart-home-troubleshooting',
    related: ['q1', 'r3'],
    schemas: ['article', 'faqPage'],
    published: '2026-05-22',
  },
  {
    id: 'm1',
    slug: '/guides/assistance-velo-electrique-location-distance',
    slugEn: '/guides/electric-bike-rental-remote-assistance',
    related: ['g2', 'q1'],
    schemas: ['article', 'faqPage'],
    published: '2026-05-22',
  },
  {
    id: 'm2',
    slug: '/guides/assistance-camping-car-van-location-distance',
    slugEn: '/guides/motorhome-van-rental-remote-assistance',
    related: ['g1', 'q1'],
    schemas: ['article', 'faqPage'],
    published: '2026-05-22',
  },
  {
    id: 'm3',
    slug: '/guides/conciergerie-airbnb-assistance-distance',
    slugEn: '/guides/airbnb-concierge-remote-assistance',
    related: ['g1', 'c6'],
    schemas: ['article', 'faqPage'],
    published: '2026-05-22',
  },
  {
    id: 'm4',
    slug: '/guides/camping-hotellerie-assistance-video-qr-code',
    slugEn: '/guides/campsite-hotel-video-support-qr-code',
    related: ['m3', 'g1'],
    schemas: ['article', 'faqPage'],
    published: '2026-05-22',
  },
  {
    id: 'm5',
    slug: '/guides/sav-electromenager-diagnostic-distance',
    slugEn: '/guides/appliance-after-sales-remote-diagnosis',
    related: ['r3', 'q1'],
    schemas: ['article', 'faqPage'],
    published: '2026-05-22',
  },
  {
    id: 'c6',
    slug: '/guides/invitation-assistance-video-personnalisee',
    slugEn: '/guides/personalized-video-support-invitation',
    related: ['c1', 'm3'],
    schemas: ['article', 'faqPage'],
    published: '2026-05-22',
  },
  {
    id: 'r2',
    slug: '/guides/first-call-resolution-assistance-video',
    slugEn: '/guides/first-call-resolution-video-support',
    related: ['r1', 'q1'],
    schemas: ['article', 'faqPage'],
    published: '2026-05-22',
  },
  {
    id: 'r3',
    slug: '/guides/qualifier-intervention-terrain-distance',
    slugEn: '/guides/qualify-on-site-intervention-remotely',
    related: ['r1', 'm5'],
    schemas: ['article', 'faqPage'],
    published: '2026-05-22',
  },
  {
    id: 'r4',
    slug: '/guides/cout-deplacement-technicien-evite-roi',
    slugEn: '/guides/avoided-technician-trip-cost-roi',
    related: ['r1', 's2'],
    schemas: ['article', 'faqPage'],
    published: '2026-05-22',
  },
  {
    id: 'r5',
    slug: '/guides/assistance-video-sans-application-client',
    slugEn: '/guides/video-support-without-customer-app',
    related: ['s2', 'c1'],
    schemas: ['article', 'faqPage'],
    published: '2026-05-22',
  },
  {
    id: 's5',
    slug: '/guides/chiffrement-assistance-video-dtls-srtp',
    slugEn: '/guides/video-support-encryption-dtls-srtp',
    related: ['s1'],
    schemas: ['article', 'faqPage'],
    published: '2026-05-22',
  },
  {
    id: 's8',
    slug: '/guides/assistance-video-sans-cookies-tracking',
    slugEn: '/guides/video-support-no-tracking-cookies',
    related: ['s1', 's3'],
    schemas: ['article', 'faqPage'],
    published: '2026-05-22',
  },
  {
    id: 's9',
    slug: '/guides/assistance-video-collectivites-marches-publics',
    slugEn: '/guides/video-support-public-sector-procurement',
    related: ['s1', 's6'],
    schemas: ['article', 'faqPage'],
    published: '2026-05-22',
  },
];

export const getGuideBySlug = (slug) =>
  GUIDE_ARTICLES.find((a) => a.slug === slug || a.slugEn === slug);

export const getGuideSlug = (article, lang) =>
  lang === 'en' ? article.slugEn : article.slug;
